import type { RouteLocationNormalized, Router } from "vue-router";
import { loginRequest, getMsalInstance } from "@/config/authConfig";
import type { PublicClientApplication, RedirectRequest } from "@azure/msal-browser";

export function registerGuard(router: Router) {
  router.beforeEach(async (to: RouteLocationNormalized) => {
    if (to.meta.requiresAuth) {
      const request = {
        ...loginRequest,
        redirectStartPage: to.fullPath
      };
      const isUserAuthenticated = await isAuthenticated(getMsalInstance(), request);
      if (!isUserAuthenticated) {
        return "/access-denied";
      }
    }

    return true;
  });
}

export async function isAuthenticated(
  instance: PublicClientApplication,
  loginRequest: RedirectRequest
): Promise<boolean> {
  try {
    await instance.handleRedirectPromise();
    const accounts = instance.getAllAccounts();
    if (accounts.length > 0) {
      return true;
    }

    await instance.loginRedirect(loginRequest);
    return true;
  } catch (e) {
    return false;
  }
}
